import React, { useEffect } from 'react'
import Login from '../components/Login/Login'
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";

const LoginPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { isAuthenticated } = useSelector((state) => state.user);
    
    // If user is already logged in, redirect to profile overview
    useEffect(() => {
        if (isAuthenticated) {
            // Optionally, honour an explicit redirect that points into profile,
            // but default to the profile overview.
            const redirect = searchParams.get('redirect');
            const target =
                redirect && redirect.startsWith("/profile")
                    ? redirect
                    : "/profile/overview";
            navigate(target, { replace: true });
        }
    }, [isAuthenticated, navigate, searchParams])
    
    return (
        <div>
            <Header />
            <Login />
            <Footer />
        </div>
    )
}

export default LoginPage